import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CommunityConfigService } from '../util';
import { CommunityShortUser } from '../../interfaces/community-item';

@Injectable({ providedIn: 'root' })
export class UserService {
  #http = inject(HttpClient);
  #internalApi = inject(CommunityConfigService).internalApi;

  getUsersBulk(userUuids: string[]): Observable<Record<string, CommunityShortUser>> {
    const httpParams = new HttpParams({
      fromObject: {
        user_uuids: userUuids.join(','),
      },
    });

    return this.#http.get<Record<string, CommunityShortUser>>(`${this.#internalApi.userUrl}/bulk/`, {
      params: httpParams,
    });
  }
}
